export default "__VITE_ASSET__DXpzP5pz__"